import { html, render } from 'lit-html';
import { classMap } from 'lit-html/directives/class-map.js';
import dayjs from 'dayjs';
import advanceFormat from 'dayjs/plugin/advancedFormat';
import Request from '../../utils/request';
import Store from './../../utils/state-management/store';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const EVENT_KEY = `.lta.pd.recentresults`;
const EVENT_CLICK_MORE = `click.more${EVENT_KEY}`;

dayjs.extend(advanceFormat);
class PlayerDashboardRecentResultsSection {
	init() {
		this.storeInstance = undefined;

		this.initLocalStoreInstance();

		this.viewMoreBtn = SelectorEngine.findOne('.js-pd-recent-results-more-btn');
		this.cardsContainer = SelectorEngine.findOne('.js-pd-recent-results-cards-container');

		this.initEvents();
	}

	initLocalStoreInstance() {
		const self = this;
		const initialState = {
			RecentMatches: [],
			currentNoOfResults: 3
		};

		const actions = {
			async loadMoreEvents(context, currentNoOfResults) {
				const payload = await self.fetchMoreEvents(currentNoOfResults);

				context.commit('setNewEvents', payload);
			}
		};

		const mutations = {
			setNewEvents(state, payload) {
				state.RecentMatches = state.RecentMatches.concat(payload.RecentMatches);
				state.currentNoOfResults += 3;

				return state;
			}
		};

		this.storeInstance = new Store({
			actions,
			mutations,
			initialState
		});

		this.storeInstance.subscribe((state, oldState) => {
			self.renderMatches(state);
		});
	}

	initEvents() {
		EventHandler.on(this.viewMoreBtn, EVENT_CLICK_MORE, () => {
			this.storeInstance.dispatch('loadMoreEvents', this.storeInstance.state.currentNoOfResults)
		});
	}

	matchCardTpl(data) {
		// eslint-disable-next-line unicorn/consistent-function-scoping
		const cardClasses = (ResultColorClass) => ({
			'u-border-danger': ResultColorClass === 'lose-color',
			'u-border-success': ResultColorClass === 'win-color',
			'u-border-primary': ResultColorClass === 'not-played-color'
		});

		// eslint-disable-next-line unicorn/consistent-function-scoping
		const cardFooterClasses = (ResultColorClass) => ({
			'is-lost': ResultColorClass === 'lose-color',
			'is-won': ResultColorClass === 'win-color',
			'is-not-played': ResultColorClass === 'not-played-color'
		});

		return html`
			${data.RecentMatches.map((card) => html`
			<div class="lta-card lta-card--match-status ${classMap(cardClasses(card.ResultColorClass))}">
				<div class="lta-card-header u-pb-0 u-border-0">
					<span class="lta-tag lta-tag--info u-fw-medium">${card.EventName}</span>
					<span class="lta-tag lta-tag--info u-fw-medium">${card.MatchType}</span>
				</div>
				<div class="lta-card-body u-py-2">
					<p class="lta-card-text u-mb-2"><strong>${card.ResultText}</strong> ${card.Opponents.join(', ')}</p>
					<p class="lta-card-text u-fw-light lta-card__match-status-sets">
						${card.SetResults.map((set, idx, sets) => html`${set.Score}${(set.TieBreak) ? html`<sup>${set.TieBreak}</sup>` : ''}${(idx < sets.length - 1) ? ',' : ''} `)}
					</p>
				</div>
				<div class="lta-card-footer u-border-0 ${classMap(cardFooterClasses(card.ResultColorClass))}">
					${card.MatchDate && typeof Date.parse(card.MatchDate) === 'number'
					? dayjs(card.MatchDate).format('dddd Do MMMM YYYY')
					: ''}
				</div>
			</div>
			`)}
		`;
	}

	renderMatches(data) {
		render(this.matchCardTpl(data), this.cardsContainer);
	}

	fetchMoreEvents(skip) {
		return Request.get(`/api/player-dashboard/recent-results?skip=${skip}&take=3`)
			.catch(() => {
				this.viewMoreBtn.classList.add('u-hidden')
			});
	}
}

export default PlayerDashboardRecentResultsSection;
